import { useTranslation, Trans } from "react-i18next";

import s1 from '../../img/InvestmentPlans/s1.svg'
import s2 from '../../img/InvestmentPlans/s2.svg'
import s3 from '../../img/InvestmentPlans/s3.svg'

function Beginner() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col xl:flex-row gap-[10px] xl:gap-[20px]">
                <div className="flex-grow xl:h-[344px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[30px] py-[20px] xl:py-[40px]">
                    <img src={s1} alt="" />
                    <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[50px]">{t('investment.4')}</p>
                    <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('investment.5')}</p>
                </div>
                <div className="flex-grow xl:h-[344px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[30px] py-[20px] xl:py-[40px]">
                    <img src={s2} alt="" />
                    <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[50px]">{t('investment.6')}</p>
                    <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('investment.7')}</p>
                </div>
                <div className="flex-grow xl:h-[344px] bg-[#F1F7FE] rounded-[4px] px-[20px] xl:px-[30px] py-[20px] xl:py-[40px]">
                    <img src={s3} alt="" />
                    <p className="poppins text-[#1A0402] text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:mt-[50px]">{t('investment.8')}</p>
                    <p className="inter text-[#000000B2] text-[14px] leading-[1.5] mt-[12px] xl:max-w-[311px]">{t('investment.9')}</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Beginner;
 